<template lang="pug">
el-dialog( v-dialogDrag :before-close="handleClose"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  :title="copyMoveTitle"
  :visible.sync="openModify" width="30%" )
  .dialog-header
    span 当前选择为:{{ checkFoldData.folderName }}
    el-tree(
      accordion
      :default-expanded-keys="unfoldIdArr"
      highlight-current
      lazy
      :load="loadNode"
      node-key="folderId"
      :props="defaultProps"
      ref="tree"
      @node-click="clickNodeTree"
      v-slot="{ node, data }")
      .labelst
        img.imglogo(:src="treeNodeIcon(node.data)", alt="logo")
        span {{data.folderName}}
  template(#footer)
    span.dialog-footer
      el-button(size="small" @click="handleClose") 取 消
      el-button( size="small" type="primary" @click="trueMoveOrCopy" ) 确 定
</template>
<script>
import { treeNodeIcon } from "@/CommonDP/utils/docPublic";
import docService from "@/CommonDP/service/doc-service";
import secondaryMenuService from "@/CommonDP/service/secondaryMenu-service";
import { mapState } from "vuex";
export default {
  name: "DocMoveAndCopy",
  props: {
    type: {
      type: String,
      default: "move"
    },
    folderId: {
      type: String,
      default: ""
    },
    selectArr: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      copyMoveTitle: "移动到",
      openModify: true,
      defaultProps: { children: "children", label: "folderName" },
      unfoldIdArr: [],
      checkFoldData: {}
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),
    prjId() {
      if (this.type === 2) return "MyDoc";
      else if (this.type === 3) return "EnterpriseDoc";
      else if (this.type === 4) return "EnterpriseDeptDoc";
      else return "";
    },
    argumentParams() {
      return {
        isRead: 1,
        priviAll: "1",
        enterpriseId: this.enterpriseId,
        versionId: "",
        isPersonal: 1,
        noRightClickMenu: true,
        type: ""
      };
    }
  },
  mounted() {
    // this.argument.enterpriseId = this.enterpriseId;
  },
  methods: {
    async loadNode(node, resolve) {
      if (node.level === 0) {
        const list = await this.getForlders("0");
        const array = list.filter(e => e.folderId === this.folderId);// 只能在当前部门文档内移动
        this.unfoldIdArr = [this.folderId];
        resolve(array);
      } else {
        const { data: { folderId = "" }} = node;
        const list = await this.getForlders(folderId);
        resolve(list);
      }
    },
    async getForlders(folderId) {
      const params = {
        ...this.argumentParams,
        folderId
      };
      const { data = [] } = await secondaryMenuService.queryEnterpriseDept(params);
      return data.filter(e => e.isFolder === 1) || [];
    },
    handleClose() {
      this.openModify = false;
      this.reject();
    },
    async clickNodeTree(data) {
      this.checkFoldData = data;
    },
    async trueMoveOrCopy() {
      if (!this.checkFoldData.folderId) {
        this.$message.warning(`请先选择需要${this.type === "move" ? "移动到" : "复制到"}的文件夹`);
      }
      const param = {
        ids: this.selectArr.map(e => e.folderId),
        prjId: "EnterpriseDeptDoc",
        enterpriseId: this.enterpriseId,
        parentId: this.checkFoldData.folderId
      };
      if (this.type === "move") {
        await docService.moveFile(param);
        this.$message.success("移动成功");
      } else {
        await docService.copyFile(param);
        this.$message.success("复制成功");
      }
      this.resolve();
    },
    treeNodeIcon(data) {
      return treeNodeIcon(data);
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-header{
  min-height: 300px;
  max-height: 600px;
  overflow-y: auto;
}
.labelst{
  // width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  img{
    margin-right: 5px;
  }
}
</style>
